export const ROUTES = {
  HOME: "/",
  SEARCH: "/search/:search",
  WINNER: "/winner",
};
